import { render, staticRenderFns } from "./ClientMessageInformation.vue?vue&type=template&id=8d0d1fe6&scoped=true&"
import script from "./ClientMessageInformation.vue?vue&type=script&lang=js&"
export * from "./ClientMessageInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClientMessageInformation.vue?vue&type=style&index=0&id=8d0d1fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0d1fe6",
  null
  
)

export default component.exports